
import { memo } from "react";
import { IIconsProps } from "./icons.model";

const CustomRedExclamationIcon = (props: IIconsProps) => {
    return (
        <i id={props.id} className='fa-solid fa-exclamation' style={{ fontSize: props.fontSize, color: props.color }} />
    );
};

export default memo(CustomRedExclamationIcon);

